var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-info flex justify-between align-center"},[_c('p',{staticClass:"copy"},[_vm._t("results")],2),_c('div',[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }